// extracted by mini-css-extract-plugin
export default {"layout":"userFollowInfo_layout__-B4dB","count":"userFollowInfo_count__k+n9J","state":"userFollowInfo_state__U98JQ"};